export default __webpack_public_path__ + "static/media/Slide21.dc04751b.JPG";